module.exports = __webpack_public_path__ + "img/error-hair.ae8e35b3.svg";